import { TSuggestedModalAction, SuggestedModalActionTypes } from './suggestedModalActions';
import { ISuggestedModalState } from './suggestedModalContext';

export const suggestedModalReducer = (
	state: ISuggestedModalState,
	action: TSuggestedModalAction,
): ISuggestedModalState => {
	switch (action.type) {
		case SuggestedModalActionTypes.SET_ALL_DATA:
			return {
				...state,
				dishInfo: action.payload.dishInfo,
				IDsSelectedRestaurant: action.payload.IDsSelectedRestaurant,
				fetchedSuggestedDishes: action.payload.fetchedSuggestedDishes,
				selectedSuggestedDishes: action.payload.selectedSuggestedDishes,
			};
		case SuggestedModalActionTypes.SET_SUGGESTED_DISH_CATEGORY:
			return {
				...state,
				selectedSuggestedDishCategory: action.payload.selectedSuggestedDishCategory,
				selectedSuggestedDishSubCategory: null,
			};
		case SuggestedModalActionTypes.SET_SUGGESTED_DISH_SUB_CATEGORY:
			return {
				...state,
				selectedSuggestedDishSubCategory: action.payload.selectedSuggestedDishSubCategory,
			};
		case SuggestedModalActionTypes.SET_FETCHED_SUGGESTED_DISHES:
			return {
				...state,
				fetchedSuggestedDishes: action.payload.fetchedSuggestedDishes,
			};
		case SuggestedModalActionTypes.SET_SUGGESTED_DISHES:
			return {
				...state,
				selectedSuggestedDishes: action.payload.selectedSuggestedDishes,
			};
		default:
			return state;
	}
};
